import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'G10-attendance-report-preview',
  templateUrl: './attendance-report-preview.component.html',
  styleUrls: ['./attendance-report-preview.component.css']
})
export class AttendanceReportPreviewComponent implements OnInit {

  @Input() popup = true;
  @Input() modalTitle = 'Security check view';
  @Input() isEdit: boolean = false;
  @Input('modalData') set modalData(val:any){
    this.data = val;
    if(val && val.attenData && val.attenData.length>0)
    this.processPagination({
      page: 1,
      limit: 5,
      totCnt: val.attenData.length,
    },this.paginationData);
    this.paginationLimit();
  };

  @Output() closeEvent = new EventEmitter();

  public data:any = {};
  /* Pagination */
  public pageNumber = 1;
  public pageLimit = '5';
  public paginationData = {
    page: 1,
    limit: 5,
    totalPage: 1,
  }
  
  // Modal variables
  public showTable: boolean = true;
  public noDataFoundEnable: boolean = false;
  public cols: any = [
    { key: 'empName', display: 'Employee name' ,headerConfig:{ isDefault: true}},
    { key: 'empRefID', display: 'Employee ID', config: { isUppercase: true },headerConfig:{ isDefault: true} },
    { key: 'isBoarded', display: 'Security boarded', config: { isVehicle: true },headerConfig:{ isDefault: true} },
  ]

  /* Table Data */
  public tableData:any = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  paginationLimit(){
    this.pageNumber = 1;
    this.pagination({page:this.pageNumber,limit: Number(this.pageLimit)});
  }


  processPagination(data, req) {
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(type){
    if(type=='next'){
      
        this.pageNumber++;
    
    }else if(type=='prev'){
      if(this.pageNumber<=1) return;
       this.pageNumber--;
    }
    this.filterPageData(this.pageNumber,Number(this.pageLimit));
  }

  filterPageData(page,limit){
    let startIndex = (page-1)*limit;
    let endIndex = (page)*limit;
    this.tableData = this.data['attenData'].slice(startIndex,endIndex);
    this.processPagination({ totCnt: this.data['attenData'].length,},{page,limit});
  }

  closePopup() {
    this.closeEvent.emit(true);
  }
}
